'use client';

import { IconBookmark } from '@tabler/icons-react';
import { useState } from 'react';
import { BlogSidebarItem } from './blog-sidebar-item';

interface NewsletterSignupProps {
	title?: string;
	description?: string;
}

export const NewsletterSignup = ({
	title = 'Stay Updated',
	description = 'Subscribe to our newsletter to get the latest updates.',
}: NewsletterSignupProps) => {
	const [email, setEmail] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [message, setMessage] = useState<{
		text: string;
		type: 'success' | 'error' | null;
	}>({
		text: '',
		type: null,
	});

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();

		if (!email) {
			setMessage({
				text: 'Please enter your email address',
				type: 'error',
			});
			return;
		}

		try {
			setIsSubmitting(true);
			// Here you would typically make an API call to subscribe the user
			// For example:
			// await fetch('/api/newsletter', {
			//   method: 'POST',
			//   headers: { 'Content-Type': 'application/json' },
			//   body: JSON.stringify({ email }),
			// });

			// Simulate API call
			await new Promise(resolve => setTimeout(resolve, 1000));

			setMessage({ text: 'Thank you for subscribing!', type: 'success' });
			setEmail('');
		} catch (error) {
			console.error('Failed to subscribe:', error);
			setMessage({
				text: 'Failed to subscribe. Please try again.',
				type: 'error',
			});
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<BlogSidebarItem icon={<IconBookmark size={18} />} title={title}>
			<p className="mb-3 text-sm text-neutral-600">{description}</p>
			<form onSubmit={handleSubmit} className="space-y-3">
				<input
					type="email"
					placeholder="Your email address"
					value={email}
					onChange={e => setEmail(e.target.value)}
					className="w-full rounded-md border border-neutral-200 bg-neutral-50 px-4 py-2 text-sm placeholder-neutral-400 focus:border-primary/50 focus:outline-none focus:ring-1 focus:ring-primary/50"
					disabled={isSubmitting}
				/>
				{message.text && (
					<p
						className={`text-xs ${message.type === 'success' ? 'text-green-600' : 'text-red-600'}`}>
						{message.text}
					</p>
				)}
				<button
					type="submit"
					disabled={isSubmitting}
					className="w-full rounded-md bg-primary px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-primary/90 disabled:opacity-70">
					{isSubmitting ? 'Subscribing...' : 'Subscribe'}
				</button>
			</form>
		</BlogSidebarItem>
	);
};
